export const formatInstallmentNumber = (installment: number, isUpfront?: boolean) => {
  if (isUpfront) {
    return 'Entrada'
  }

  return installment === 0 ? 'Entrada' : `${installment}ª parcela`
}
